import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";
import { useAuth } from "../Provider/AuthProvider";

const AuthProtected = (props: any) => {
    const dispatch: any = useDispatch();
    const { user } = useAuth();


    useEffect(() => {
        if (user) {
            setAuthorization(user.token);
        } else if (!user && !user.token) {
            dispatch(logoutUser());
        }
   

    }, [user, user.token, dispatch]);

    /*
      Navigate is un-auth access protected routes via url
      */

    if (!user && !user.token) {
        return (
            <Navigate to={{ pathname: "/login" }} />
        );
    }

    return <>{props.children}</>;
};


export default AuthProtected;
